<template>
  <div>
    <v-card :loading="loading">
      <v-list class="pt-0" three-line v-if="activities">
        <v-subheader key="activity-feed" v-if="preview">{{ $t('activities.headline') }}</v-subheader>
        <template v-for="(item, index) in activities">
          <v-list-item :key="item.uuid">
            <v-list-item-content class="align-self-center">
              <v-list-item-title class="mb-2 text-subtitle-1">{{ item.message }}</v-list-item-title>
              <v-list-item-subtitle class="text-subtitle-2 font-weight-light">{{ item.created }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="d-flex align-self-center">
              <v-list-item-action-text class="text-subtitle-1 font-weight-light">
                {{ getPointsSimbol(item.activity_class) }}
                {{ $tc('activities.activityValue', item.points, {points: item.points}) }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index + 1 < activities.length" :key="index"></v-divider>
        </template>
      </v-list>
      <template v-if="preview">
        <v-divider></v-divider>
        <v-row class="text-center">
          <v-col>
            <v-btn to="activities" text color="primary">{{ $t('activities.showAll') }}</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card>
  </div>
</template>

<script>
  import _ from 'lodash';

  export default {
    name: "ActivityFeed",
    props: ['data'],
    data() {
      return {
        loading: false
      }
    },
    computed: {
      preview() {
        return _.get(this.data, 'preview', false);
      },
      activities() {
        let activities = this.$store.state.activities;
        if (this.preview) {
          activities = this.$store.state.activities.slice(0, 4)
        }
        return activities;
      }
    },
    mounted() {
      if (!this.preview) {
        this.fetchActivities();
      }
    },
    methods: {
      async fetchActivities() {
        this.loading = true;
        try {
          await this.$store.dispatch('fetchActivities');
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false;
        }
      },
      getPointsSimbol(activityClass) {
        if (activityClass === 0) {
          return '+'
        } else if (activityClass === 1) {
          return '-'
        }
        return ''
      }
    }
  }
</script>
